<template>
  <div
    class="dashboard-shell app-shell"
    :style="{
      marginTop: headerHeight + 'px',
      height: 'calc(100vh - ' + headerHeight + 'px - 20px)'
    }"
  >
    <div
      class="dashboard-sidebar app-sidebar"
      :style="{ top: headerHeight + 'px' }"
    >
      <el-menu
        class="dashboard-menu"
        :default-active="type"
        background-color="transparent"
        @select="selectType"
      >
        <el-menu-item
          v-if="p('Dashboard.Pod Capacitance.View')"
          index="pod_capacitance"
        >
          <i class="el-icon-data-analysis"></i>
          <span slot="title">{{ $t('text.pod_capacitance') }}</span>
        </el-menu-item>
        <el-menu-item v-if="p('Dashboard.Pod Accel.View')" index="pod_accel">
          <i class="el-icon-odometer"></i>
          <span slot="title">{{ $t('text.pod_accel') }}</span>
        </el-menu-item>
        <el-menu-item
          v-if="p('Dashboard.Pod Data Stream.View')"
          index="pod_data_stream"
        >
          <i class="el-icon-connection"></i>
          <span slot="title">pod data stream</span>
        </el-menu-item>
      </el-menu>
    </div>

    <div class="dashboard-main app-main">
      <div class="dashboard-page">
        <AppBreadcrumb
          root="Dashboard"
          :current="typeTitle"
          @root-click="selectType(firstAvailableType)"
        />

        <PodCapacitance
          :latestCaliPodChartDataPoint="latestCaliPodChartDataPoint"
          :countDown="countDown"
          :sensorData="sensorData"
          :latestTime="latestTime"
          v-show="type === 'pod_capacitance'"
          ref="capacitance"
        />
        <PodAccel
          :latestCaliPodChartDataPoint="latestCaliPodChartDataPoint"
          v-show="type === 'pod_accel'"
          ref="accel"
        />
        <PodDataStream v-show="type === 'pod_data_stream'" ref="dataStream" />
      </div>
    </div>
  </div>
</template>

<script>
import PodCapacitance from '@/components/home/PodCapacitance.vue'
import PodAccel from '@/components/home/PodAccel.vue'
import PodDataStream from '@/components/home/PodDataStream.vue'
import headerHeight from '@/mixins/headerHeight'
import AppBreadcrumb from '@/components/AppBreadcrumb'
// import ApiService from '@/services/ApiService.js'
// import swal from 'sweetalert'

const TYPE_TITLES = {
  pod_capacitance: 'Pod Capacitance',
  pod_accel: 'Pod Accel',
  pod_data_stream: 'Pod Data Stream'
}

export default {
  data() {
    return {
      type: 'pod_capacitance',
      loading: false,
      latestCaliPodChartDataPoint: {},
      timer: '',
      countDown: 30,
      podLatest30Data: [],
      sensorData: this.initSensorData(),
      latestTime: ''
    }
  },
  mixins: [headerHeight],
  mounted() {
    this.type = this.firstAvailableType
    this.timer = setInterval(this.getData, 1000)
  },
  components: {
    PodCapacitance,
    PodAccel,
    PodDataStream,
    AppBreadcrumb
  },
  computed: {
    typeTitle() {
      return TYPE_TITLES[this.type] || ''
    },
    firstAvailableType() {
      return this.$permission('Dashboard.Pod Capacitance.View')
        ? 'pod_capacitance'
        : this.$permission('Dashboard.Pod Accel.View')
        ? 'pod_accel'
        : 'pod_data_stream'
    }
  },
  watch: {
    '$store.state.pods.selectedPod': function() {
      clearInterval(this.timer)
      this.countDown = 30
      this.podLatest30Data = []
      this.sensorData = this.initSensorData()
      this.timer = setInterval(this.getData, 1000)
    }
  },
  methods: {
    selectType(type) {
      this.type = type
      this.$nextTick(() => {
        const ref =
          type === 'pod_capacitance'
            ? this.$refs.capacitance
            : type === 'pod_accel'
            ? this.$refs.accel
            : null
        if (ref && ref.chart && ref.chart.resize) ref.chart.resize()
      })
    },
    initSensorData() {
      return [
        {
          key: this.$t('text.value'),
          sensor1: '--',
          sensor2: '--'
        },
        {
          key: this.$t('text.min'),
          sensor1: '--',
          sensor2: '--'
        },
        {
          key: this.$t('text.max'),
          sensor1: '--',
          sensor2: '--'
        }
      ]
    },
    getData() {
      // We dont't need this anymore
      // if (!this.$store.state.pods.selectedPod.podId) return false
      // this.loading = true
      // ApiService.LatestCaliPodChartDataPoint(
      //   this.$store.state.pods.selectedPod.podId
      // )
      //   .then(response => {
      //     this.loading = false
      //     this.latestCaliPodChartDataPoint = response.data || {}
      //     let vm = this
      //     if (response.data) {
      //       this.$nextTick(() => {
      //         vm.$refs.capacitance.updateChart()
      //         vm.$refs.accel.updateChart()
      //       })
      //     }
      //     // prevent calculate other pod data
      //     if (
      //       response.data &&
      //       response.data.rawData !== this.$store.state.pods.selectedPod.podId
      //     )
      //       return
      //     this.podLatest30Data.push({
      //       sensor1: this.latestCaliPodChartDataPoint.sensor1,
      //       sensor2: this.latestCaliPodChartDataPoint.sensor2,
      //       timeStamp: this.latestCaliPodChartDataPoint.timeStamp
      //     })
      //     this.handleClearLatest30Data()
      //   })
      //   .catch(() => {
      //     this.loading = false
      //     this.handleClearLatest30Data()
      //     swal({
      //       icon: 'error',
      //       timer: 2000,
      //       title: this.$t('text.failed')
      //     })
      //   })
    },
    median(numbers) {
      var median = 0,
        numsLen = numbers.length
      numbers = numbers.sort(function(a, b) {
        return a - b
      })
      if (numsLen % 2 === 0) {
        // is even
        median = (numbers[numsLen / 2 - 1] + numbers[numsLen / 2]) / 2
      } else {
        // is odd
        median = numbers[(numsLen - 1) / 2]
      }
      return median
    },
    //Once it goes to 0 you need to calculate median and min and max value from that 30 data points
    handleClearLatest30Data() {
      this.countDown--
      if (this.countDown <= 0) {
        let latest30Sensor1 = this.podLatest30Data
          .map(item => {
            return item.sensor1
          })
          .filter(item => {
            return typeof item !== 'undefined'
          })
        let latest30Sensor2 = this.podLatest30Data
          .map(item => {
            return item.sensor2
          })
          .filter(item => {
            return typeof item !== 'undefined'
          })
        let latestTimes = this.podLatest30Data
          .map(item => {
            return item.timeStamp
          })
          .filter(item => {
            return typeof item !== 'undefined'
          })
        this.latestTime = latestTimes[latestTimes.length - 1]
        this.$set(this.sensorData, 0, {
          key: this.$t('text.value'),
          sensor1: latest30Sensor1.length ? this.median(latest30Sensor1) : '--',
          sensor2: latest30Sensor2.length ? this.median(latest30Sensor2) : '--'
        })
        this.$set(this.sensorData, 1, {
          key: this.$t('text.min'),
          sensor1: latest30Sensor1.length ? Math.min(...latest30Sensor1) : '--',
          sensor2: latest30Sensor2.length ? Math.min(...latest30Sensor2) : '--'
        })
        this.$set(this.sensorData, 2, {
          key: this.$t('text.max'),
          sensor1: latest30Sensor1.length ? Math.max(...latest30Sensor1) : '--',
          sensor2: latest30Sensor2.length ? Math.max(...latest30Sensor2) : '--'
        })
        this.countDown = 30
        this.podLatest30Data = []
      }
    }
  },
  beforeDestroy() {
    clearInterval(this.timer)
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/css/theme.scss';

.dashboard-shell {
  overflow: hidden;
}

.dashboard-main {
  overflow: hidden;
}

.dashboard-page {
  flex: 1;
  padding: 20px 24px 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;

  /deep/ .page-title {
    display: none;
  }
  /deep/ .title-wrapper .title {
    display: none;
  }

  // ── Content component fills remaining height ─────────────────────────
  /deep/ .chart-data-page-content {
    flex: 1;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    max-width: none;
    margin: 0 0 20px;
  }

  // ── Toolbar card ─────────────────────────────────────────────────────
  /deep/ .title-wrapper {
    flex-shrink: 0;
    background: #fff;
    border: 1px solid var(--border);
    border-radius: 10px;
    padding: 14px 20px;
    display: flex;
    align-items: center;
    gap: 24px;
    margin-bottom: 16px;
    position: static;
  }

  /deep/ .pods-select-wrapper {
    .pods-select-label {
      font-size: 13px;
      font-weight: 500;
      color: var(--text2);
    }
  }

  /deep/ .status-table {
    position: static !important;
    right: auto !important;
    top: auto !important;
    display: flex;
    align-items: center;

    .utc-wrapper {
      display: flex;
      align-items: center;
      gap: 8px;
      font-size: 13px;
      color: var(--text2);
      white-space: nowrap;

      .utc-select {
        width: 200px;
      }
    }

    .el-table {
      display: none;
    }
  }

  // ── Main content card fills remaining space ───────────────────────────
  /deep/ .page-content {
    flex: 1;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    background: #fff;
    border: 1px solid var(--border);
    border-radius: 10px;
    padding: 20px;
  }

  // ── Stats + timer row (fixed height) ─────────────────────────────────
  /deep/ .stats-timer-row {
    flex-shrink: 0;
    display: flex;
    align-items: center;
    gap: 28px;
    margin-bottom: 20px;
  }

  // ── MEDIAN table — auto width, ultra-compact rows ────────────────────
  /deep/ .median-table {
    flex-shrink: 0;
    width: auto !important;

    .el-table__header th {
      background: var(--bg2) !important;
      font-size: 10px !important;
      font-weight: 600 !important;
      text-transform: uppercase;
      color: var(--text2) !important;
      padding: 2px 8px !important;
      letter-spacing: 0.04em;
    }
    .el-table__body td {
      padding: 2px 8px !important;
      font-size: 11px !important;
      color: var(--text) !important;
      line-height: 1.3;
    }
  }

  /deep/ .circle-box {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 8px;
    flex-shrink: 0;
    min-width: 200px;
    padding: 0 12px;
  }

  /deep/ .circle-ring {
    width: 120px !important;
    height: 120px !important;
    border-radius: 60px !important;
    border-width: 6px !important;
    font-size: 18px !important;
    font-weight: 600;
    margin-left: 0 !important;
    color: var(--text);
  }

  /deep/ .latest-time-block {
    text-align: center;

    .latest-time-label {
      font-size: 10px;
      font-weight: 600;
      text-transform: uppercase;
      letter-spacing: 0.05em;
      color: var(--text3);
      margin-bottom: 2px;
    }
    .latest-time-val {
      font-size: 11px;
      color: var(--text2);
      font-variant-numeric: tabular-nums;
    }
  }

  // ── Chart section label (fixed height) ───────────────────────────────
  /deep/ .chart-section-label {
    flex-shrink: 0;
    font-size: 13px;
    font-weight: 600;
    color: var(--text);
    margin-bottom: 8px;
  }

  // ── eCharts/chart divs fill all remaining space ───────────────────────
  /deep/ #echarts,
  /deep/ #chart {
    flex: 1 !important;
    min-height: 0 !important;
    height: auto !important;
  }

  // ── Pod Data Stream ───────────────────────────────────────────────────
  /deep/ .export-data {
    flex: 1;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    margin-bottom: 20px;
  }
  /deep/ .export-pod-data {
    flex: 1;
    width: auto !important;
    margin-left: 0 !important;
    margin-right: 0 !important;
    display: flex;
    flex-direction: column;
    overflow: hidden;

    .page-content {
      flex: 1;
      display: flex;
      flex-direction: column;
      overflow: hidden;
      background: #fff;
      border: 1px solid var(--border);
      border-radius: 10px;
      padding: 20px;
    }
    .raw-data-wrapper {
      flex: 1;
      min-height: 0;
      height: auto !important;
      overflow: auto;
    }
    .header-grey-font {
      font-size: 13px;
      font-weight: 600;
      color: var(--text);
    }
  }
}
</style>
